import React from 'react';
import { Link } from 'react-router-dom';
interface CTASectionProps {
  title?: string;
  description?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}
export function CTASection({
  title = 'Need Professional Fiduciary Support?',
  description = 'Every situation is different. Tell us what you are managing and we will explain how we can help.',
  primaryLabel = "Let's Discuss Your Needs",
  primaryTo = '/contact',
  secondaryLabel = 'Explore Our Services',
  secondaryTo = '/services'
}: CTASectionProps) {
  return <section className="bg-navy-900" data-id="element-68" data-mp="2v682ilucbx43">
      <div className="mx-auto flex max-w-content flex-col gap-8 px-6 py-16 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-69" data-mp="2v79hh1eh93r3">
        <div className="max-w-xl" data-id="element-70" data-mp="307fc8qg1n6de">
          <h2 className="font-serif text-[28px] leading-tight text-white sm:text-[34px]" data-id="element-71" data-mp="354ntmotdb6dl">
            {title}
          </h2>
          <p className="mt-4 text-[16px] leading-relaxed text-navy-200" data-id="element-72" data-mp="3a4jzyupjf9wb">
            {description}
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0" data-id="element-73" data-mp="217jiwdndewf5">
          <Link to={primaryTo} className="bg-gold-500 px-7 py-3.5 text-center text-[15px] font-medium text-navy-950 transition-colors duration-150 ease-out hover:bg-gold-400" data-id="element-74" data-mp="1w63wah5johun">
            {primaryLabel}
          </Link>
          <Link to={secondaryTo} className="border border-white/25 px-7 py-3.5 text-center text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-75" data-mp="1n8thwmxfkcli">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>;
}